import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';

@Component({
    selector: 'app-header-balance',
    templateUrl: './header-balance.component.html',
    styleUrls: ['./header-balance.component.scss']
})
export class HeaderBalanceComponent implements OnInit  {
    @Input() public customHeader: string = 'SALDO DISPONÍVEL';
    @Input() public headerStyles: string = 'font-small--bold font-gray-color--darker';
    @Input() public balanceStyles: string = 'font-subtitle-df--bold font-light-color';

    public consolidatedPositionSubscription: Subscription;
    public consolidatedPosition: any;

    private limitIncreased: boolean = false;

    constructor(private store: Store<AppState>) { }

    public ngOnInit(): void {
        this.consolidatedPositionSubscription = this.store.select((s) => s.finance.consolidatePosition)
        .subscribe((position) => {
            this.consolidatedPosition = position;
        });
    }

    get balance() {
        if (!this.consolidatedPosition) return 0;

        if (this.limitIncreased) {
            return this.consolidatedPosition.totalOperationGuarantee;
        }
        return this.consolidatedPosition.accountBalance;
    }

}
